import React from 'react';
import PrimaryCareEdit from '../../containers/NurseFunctions/PrimaryCareEdit';
const PrimaryCareDoctorEdit = () => {
    return (
        <PrimaryCareEdit isDoctor = {true}/>
    );
};
export default PrimaryCareDoctorEdit;
